import React, { useEffect, useState, } from 'react';
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import { buttonProcessGet, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, languageObjGet, isUndNullEmp, awaitDelay, } from '../../helpers/settings';
import axios from 'axios';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { apartmentUserModelGet } from '../../models/apartments/apartmentUser';
import { condominiumBoardRoleModelGet } from '../../models/condominiumBoard/role';

const currentMethod = 'ElectionApplicantsAddEditDetails';

const { app, icons, images, labels, messages, react: reactSett, } = globalSettings;
const { backend, } = app;

export default function ElectionApplicantsAddEditDetails({
    $ = {},
    auth = {},
    electionApplicant = {
        userElectionId: '',
        condominiumBoardRoleId: '',
    },
    setElectionApplicant = () => { },
    dtId = '',
    setElectionApplicants = () => { },
    electionApplicants = [],
    showModal = false,
    setShowModal = () => { },
    userDataGetAsync = async ({ userElectionid = '', condominiumBoardRoleId = '', processValuesTwo = {}, subMethod = '', }) => { },
    processValues = {
        type: 0,
        users: [],
        condominiumBoardRoles: [condominiumBoardRoleModelGet({})],
    },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const [applicantError, setApplicantError] = useState('');
    const [roleError, setRoleError] = useState('');
    const [floorError, setFloorError] = useState('');
    const [apartmentError, setApartmentError] = useState('');
    //const inputFloorId = 'inputFloor';
    //const inputApartmentId = 'inputApartment';
    const [applicant, setApplicant] = useState({ fullName: '', floor: 0, identifier: '', roleDescription: '' });
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-warning',
                id: 'btnModalElectionApplicantsAddEditDetailsSave',
            },
            back: {
                className: 'btn btn-outline-success mx-1',
                id: 'btnModalElectionApplicantsAddEditDetailsBack',
            },
            close: {
                className: 'close btn-danger fas fa-window-close',
                id: 'btnModalElectionApplicantsAddEditDetailsClose',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        // dataTables: {
        //     buildings: {
        //         inputs: {
        //             search: {
        //                 id: `${dtBuildingsId}_filter input`,
        //                 className: '',
        //             },
        //         },
        //         selects: {
        //             entries: {
        //                 id: `${dtBuildingsId}_length select`,
        //                 className: '',
        //             },
        //         },
        //     },
        // },
        icons: {
            save: {
                id: 'iconModalElectionApplicantsAddEditDetailsSave',
                className: icons?.save,
            },
            back: {
                id: 'iconModalElectionApplicantsAddEditDetailsBack',
                className: icons?.arrowCircleLeft,
            },
        },
        inputs: {
            floor: {
                id: 'inputModalElectionApplicantsAddEditDetailsFloor',
                className: 'form-control bg-transparent text-black',
            },
            identifier: {
                id: 'inputModalElectionApplicantsAddEditDetailsIdentifier',
                className: 'form-control bg-transparent text-black',
            },
        },
        radios: {
            // even: {
            //     id: 'radioModalElectionApplicantsAddEditDetailsEven',
            //     className: 'icheck-primary d-inline mx-4',
            // },
            // odd: {
            //     id: 'radioModalElectionApplicantsAddEditDetailsOdd',
            //     className: 'icheck-primary d-inline',
            // },
            // both: {
            //     id: 'radioModalElectionApplicantsAddEditDetailsBoth',
            //     className: 'icheck-primary d-inline mx-4',
            // },
        },
        selects: {
            users: {
                id: 'selModalElectionApplicantsAddEditDetailsUsers',
                className: 'form-select',
            },
            roles: {
                id: 'selModalElectionApplicantsAddEditDetailsRoles',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spModalElectionApplicantsAddEditDetailsSave',
                className: '',
            },
            back: {
                id: 'spModalElectionApplicantsAddEditDetailsBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region methods
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            if (processValues?.type !== 0) {
                response = await dataSetAsync({
                    id: electionApplicant?.userElectionId,
                    roleId: (processValues?.type === 2 ? electionApplicant?.condominiumBoardRoleId : ''),
                    dataGet: (processValues?.type === 2),
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    return;
                }
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const errorDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errorDefaultSetAsync';
        let response = responseGet();
        try {
            setFloorError('');
            setApplicantError('');
            setApartmentError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }
            setShowModal(!isModalClose);
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region variables
            let electionApplicantsLocal = [];
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: electionApplicant?.userElectionId, subMethod: currentMethod, })?.result) {
                setApplicantError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: electionApplicant?.condominiumBoardRoleId, subMethod: currentMethod, })?.result) {
                setRoleError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: electionApplicants, subMethod: currentMethod, })?.result && electionApplicants?.length > 0) {
                electionApplicantsLocal = electionApplicants?.filter(({ userElectionId, condominiumBoardRoleId }) => userElectionId === electionApplicant?.userElectionId && condominiumBoardRoleId === electionApplicant?.condominiumBoardRoleId);
                if (processValues?.type === 0) {
                    //localElectionApplicant = electionApplicants.filter(({ userElectionId, condominiumBoardRoleId }) => userElectionId === electionApplicant.userElectionId && condominiumBoardRoleId === electionApplicant.condominiumBoardRoleId);
                } else if (processValues?.type === 1) {
                    electionApplicantsLocal = electionApplicantsLocal?.filter(({ id, }) => id !== electionApplicant?.id);
                }

                if (!isUndNullEmp({ data: electionApplicantsLocal, subMethod: currentMethod, })?.result && electionApplicantsLocal?.length > 0) {
                    response = await userDataGetAsync({
                        userElectionid: electionApplicantsLocal?.[0]?.userElectionId,
                        condominiumBoardRoleId: electionApplicantsLocal?.[0]?.condominiumBoardRoleId,
                        processValuesTwo: processValues,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return response;
                    }
                    response.msgType = 1;
                    response.isWarning = true;
                    response.msgText = `${messages?.thisInformationHasAlreadyBeenRecorded?.[languageObj?.id]}<br/>`;
                    response.msgText += `${labels?.user?.[languageObj?.id]}: <b>${response?.result?.fullName}</b><br/>`;
                    response.msgText += `${labels?.role?.[languageObj?.id]}: <b>${response?.result?.role?.description}</b><br/>`;
                    response.msgText += `${messages?.pleaseEnterDifferentOne?.[languageObj?.id]}`;
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                }
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const condominiumBoardElectionDetailAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'condominiumBoardElectionDetailAddPostAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region initialize
            response = await errorDefaultSetAsync({ subMethod: currentMethod, });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region data set
            // response = condominiumBoardElectionDataSet();
            // if (!response?.isSuccess || response?.isWarning) {
            //     sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
            //     return;
            // }
            //#endregion data set

            //#region formDataValidateAsync
            response = await formDataValidateAsync({ subMethod: currentMethod, });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion formDataValidateAsync

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region create condominium board election (applicant)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                condominiumBoardElectionDetail: electionApplicant,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCondominiumBoardElectionDetails}/`
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const electionApplicantLocal = response?.result;
            setElectionApplicants([...electionApplicants, electionApplicantLocal]);
            //#endregion create condominium board election (applicant)

            //#region add record dt condominum board election
            //#region data get user
            response = await userDataGetAsync({
                userElectionid: electionApplicantLocal?.userElectionId,
                condominiumBoardRoleId: electionApplicantLocal?.condominiumBoardRoleId,
                processValuesTwo: null,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const userLocal = response?.result;
            //#endregion data get user

            const dtRows = [
                userLocal?.fullName,
                userLocal?.floor,
                userLocal?.identifier,
                userLocal?.role?.description,
                userLocal?.role?.hierarchy,
                buttonProcessGet({
                    id: electionApplicantLocal?.id,
                    description: userLocal?.fullName,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ];

            $(`#${dtId}`)?.DataTable()?.row?.add(dtRows)?.draw(true);

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            //#endregion add record dt condominum board election

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const condominiumBoardElectionDetailEditPostAsync = async (e = {}, subMethod = '',) => {
        const currentMethod = 'condominiumBoardElectionDetailEditPostAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region initialize
            response = await errorDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region formDataValidateAsync
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion formDataValidateAsync

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region update condominium board election (details)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                condominiumBoardElectionDetail: electionApplicant,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCondominiumBoardElectionDetails}/${electionApplicant?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const electionApplicantLocal = response?.result;
            let electionApplicantsLocal = electionApplicants?.filter(({ id }) => id !== electionApplicant?.id);
            setElectionApplicants([...electionApplicantsLocal, electionApplicantLocal]);
            //#endregion update condominium board election (details)

            //#region data get user
            response = await userDataGetAsync({
                userElectionid: electionApplicantLocal?.userElectionId,
                condominiumBoardRoleId: electionApplicantLocal?.condominiumBoardRoleId,
                processValuesTwo: null,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const userLocal = response?.result;
            //#endregion data get user

            //#region update record condominium board election (details)
            const dtRows = [
                userLocal?.fullName,
                userLocal?.floor,
                userLocal?.identifier,
                userLocal?.role?.description,
                userLocal?.role?.hierarchy,
                buttonProcessGet({
                    id: electionApplicantLocal?.id,
                    description: userLocal?.fullName,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ];

            $(`#${dtId}`)?.DataTable()?.row(processValues?.rowIndex).data(dtRows)?.draw(true);

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            //#endregion update record condominium board election (details)

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const condominiumBoardElectionDataSet = () => {
    //     let response = responseGet();
    //     try {
    //         // const localStartDate = $(`#${startDateId}`)?.datetimepicker('date')?._d;
    //         // electionApplicant.startDate = !isUndefined(localStartDate) ? localStartDate : electionApplicant.startDate;

    //         // const localEndDate = $(`#${endDateId}`)?.datetimepicker('date')?._d;
    //         // electionApplicant.endDate = !isUndefined(localEndDate) ? localEndDate : electionApplicant.endDate;
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: condominiumBoardElectionDataSet<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code
    const dataSetAsync = async ({ id = '', roleId = '', dataGet = false, subMethod = '', }) => {
        const currentMethod = 'dataSetAsync';
        let response = responseGet();
        try {
            //#region variables
            const floor = $(`#${controls?.inputs?.floor?.id}`);
            let apartment = apartmentUserModelGet({});
            const apartmentIdentifier = $(`#${controls?.inputs?.identifier?.id}`);
            //#endregion variables

            floor.val('');
            apartmentIdentifier.val('');

            //#region methods
            apartment = processValues?.users?.filter(({ userId, }) => userId === id);
            if (!isUndNullEmp({ data: apartment, subMethod: currentMethod, })?.result && apartment?.length > 0) {
                floor.val(apartment?.[0]?.apartment?.floor);
                apartmentIdentifier.val(apartment?.[0]?.apartment?.identifier);

                if (dataGet) {
                    const role = processValues?.condominiumBoardRoles?.filter(({ id, }) => id === roleId);

                    setApplicant({
                        fullName: `${apartment?.[0]?.user?.firstName} ${apartment?.[0]?.user?.lastName}`,
                        floor: apartment?.[0]?.apartment?.floor,
                        identifier: apartment?.[0]?.apartment?.identifier,
                        roleDescription: (!isUndNullEmp({ data: role, subMethod: currentMethod, })?.result && role?.length > 0 && !isUndNullEmp({ data: role?.[0]?.description, subMethod: currentMethod, })?.result ? role?.[0]?.description : ''),
                    });
                }
            }

            setElectionApplicant({ ...electionApplicant, userElectionId: id, });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactSett?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${reactSett?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${reactSett?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.selects?.users?.id}`)?.attr('disabled', (processType !== 0));
            //$(`#${controls?.inputs?.floor?.id}`)?.attr('readOnly', (processType !== 0));
            //$(`#${controls?.inputs?.identifier?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.selects?.roles?.id}`).attr('disabled', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : reactSett?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.applicants?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.applicants?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(reactSett?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(reactSett?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(reactSett?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.applicant?.[languageObj?.id]}
                        style={styles?.cardHeaderLogo}
                        src={images?.applicants}></img> - {labels?.applicant?.[languageObj?.id]} ({processValues?.type === 0 ?
                            labels?.add?.[languageObj?.id]?.toLowerCase() :
                            processValues?.type === 1 ?
                                labels?.edit?.[languageObj?.id]?.toLowerCase() :
                                labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    //className='close btn-danger fas fa-window-close'
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form  btnClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processValues?.type === 0 ?
                condominiumBoardElectionDetailAddPostAsync({ e: e, subMethod: 'form - onSumit', }) :
                (processValues?.type === 1 ?
                    condominiumBoardElectionDetailEditPostAsync(e) :
                    e?.preventDefault())}>
                <Modal.Body>
                    {/* <form onSubmit={(e) => processValues?.type === 0 ?
                    condominiumBoardElectionDetailAddPostAsync(e) :
                    (processValues?.type === 1 ?
                        condominiumBoardElectionDetailEditPostAsync(e) :
                        null)}> */}

                    {/* <div className='card card-primary card-outline shadow-lg'> */}
                    {/*card header*/}
                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={labels?.applicant?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.applicant}></img> - {labels?.applicant?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/*card body*/}
                    {/* <div className='card-body '> */}
                    {processValues?.type !== 2 ?
                        <div>
                            <div className='row '>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.users?.id}
                                                className={controls?.selects?.users?.className}
                                                //autoFocus
                                                //className='form-select'
                                                //onChange={(e) => setElectionApplicant({ ...electionApplicant, 'description': e?.target?.value, })}
                                                //onChange={(e) => dataSetAsync(e)}
                                                onChange={(e) => dataSetAsync({ id: e?.target?.value, roleId: '', dataGet: false, subMethod: 'sel  apartmentUsers' })}
                                                onFocus={() => setApplicantError('')}
                                                placeholder={labels?.name?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.name?.[languageObj?.id]}
                                                defaultValue={electionApplicant?.userElectionId || ''} >
                                                <option id='' key='' value=''>{messages?.selectApplicant?.[languageObj?.id]}</option>
                                                {processValues?.users?.map((detail, index) => (<option key={index} value={detail?.userId}>{detail?.user?.firstName || ''} {detail?.user?.lastName || ''}</option>))}
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.user} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(applicantError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row '>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.floor?.id}
                                                className={controls?.inputs?.floor?.className}
                                                //id={inputFloorId}
                                                //className='form-control bg-transparent text-black'
                                                disabled={true}
                                                onFocus={() => setFloorError('')}
                                                placeholder={labels?.floor?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.floor?.[languageObj?.id]}
                                                type='text' />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.layerGroup} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(floorError)}</div>
                                    </div>
                                </div>

                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.identifier?.id}
                                                className={controls?.inputs?.identifier?.className}
                                                //id={inputApartmentId}
                                                //className='form-control bg-transparent text-black'
                                                disabled
                                                onFocus={() => setApartmentError('')}
                                                placeholder={labels?.apartment?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.apartment?.[languageObj?.id]}
                                                type='text' />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.houseUser} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(apartmentError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row '>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.roles?.id}
                                                className={controls?.selects?.roles?.className}
                                                //className='form-select'
                                                onChange={(e) => setElectionApplicant({ ...electionApplicant, 'condominiumBoardRoleId': e?.target?.value, })}
                                                onFocus={() => setRoleError('')}
                                                placeholder={labels?.role?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.role?.[languageObj?.id]}
                                                defaultValue={electionApplicant?.condominiumBoardRoleId || ''} >
                                                <option id='' key='' value=''>{messages?.selectRole?.[languageObj?.id]}</option>
                                                {processValues?.condominiumBoardRoles?.map((detail, index) => (<option key={index} value={detail?.id}>{detail?.description}</option>))}
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.idBadge} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(roleError)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        // Details
                        <div className='text-muted'>
                            <div className='row'>
                                <div className='col-md-4'>
                                    {labels?.name?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{applicant.fullName}</b>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    {labels?.floor?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{applicant.floor}</b>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    {labels?.apartment?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{applicant.identifier}</b>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    {labels?.role?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{applicant.roleDescription}</b>
                                </div>
                            </div>

                        </div>
                    }
                    {/* </div> */}

                    {/*card footer*/}
                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-warning'
                                    hidden={processValues?.type === 2}
                                    tooltip='tooltip'
                                    title={labels?.save?.[languageObj?.id]}
                                    type='submit'>
                                    <i className={icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-success mx-1'
                                    tooltip='tooltip'
                                    title={labels?.close?.[languageObj?.id]}
                                    type='button'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}
                    {/* </div> */}

                    {/* </form> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            //className='btn btn-outline-warning'
                            hidden={processValues?.type === 2}
                            tooltip='tooltip'
                            title={labels?.save?.[languageObj?.id]}
                            type='submit'>
                            {/* <i className={icons?.save}></i> */}
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            //className='btn btn-outline-success mx-1'
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='button'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                            {/* <i className={icons?.arrowCircleLeft}></i> */}
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}